export default __webpack_public_path__ + "static/media/Hotstar.4e700586.png";